'use client';

import Image from 'next/image';
import usePrimeStore from '@/src/lib/state-stores/primeStore';

const PrimeComponent = () => {
  const { prime } = usePrimeStore();

  return (
    <div>
      {prime?.primeEnabled && prime?.activeSubscription ? (
        <Image
          src={'/assets/prime.svg'}
          alt="order"
          width={'20'}
          height={'21'}
          className="h-[21px] w-[20px]"
        />
      ) : (
        <Image
          src={'/assets/Group.svg'}
          alt="Group"
          width={'30'}
          height={'30'}
          className="h-8 w-8"
        />
      )}
    </div>
  );
};

export default PrimeComponent;
